import React, { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { observer } from "mobx-react-lite";
import { useMutation, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import {
  LOAD_CARD_DETAILS,
  COUPONS,
  LOAD_SAVINGSACCOUNT,
  LOAD_WALLET,
  LOAD_PROFILE_INFO,
} from "GraphQL/Queries";
import { Button } from "components/buttons";
import { ReactComponent as InfoFill } from "assets/icons/info-fill.svg";
import { ReactComponent as WalletIcon } from "assets/icons/wallet.svg";
import { ReactComponent as StripeIcon } from "assets/icons/stripe.svg";
import { ReactComponent as WireTransferIcon } from "assets/icons/wire-transfer.svg";
import { ReactComponent as Close } from "../../assets/img/close-modal.svg";

import { logoutUser } from "utils/helpers";
import Fail from "assets/icons/fail.png";
import Success from "assets/img/success.png";

import Payment from "utils/stripe/payment";

import moment from "moment";
import {
  PAY_WITH_CARD_MUTATION,
  SEND_OTP,
  TRIPVAULT_MUTATION,
  WIRE_TRANSFER,
  TRANSFER_FUNDS_MUTATION,
  RESEND_EMAIL_VERIFICATION_MUTATION,
} from "GraphQL/Mutations";
import { formatter } from "utils/helpers";
import vaultStore from "stores/vaultStore";
import {
  buttonToast,
  errorToast,
  successToast,
  warningToast,
} from "components/toast/toast";
import { BsChevronLeft } from "react-icons/bs";

import Loader from "components/loader/Loader";
import { GrCheckmark } from "react-icons/gr";
import { BiRightArrow } from "react-icons/bi";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { ReactComponent as RadioOn } from "assets/icons/radio-on.svg";
import { ReactComponent as RadioOff } from "assets/icons/radio-off.svg";
import { Input } from "components/input/Input";
import { images } from "constants";
import { DASHBOARD } from "router/router";

const PaymentMethod = ({
  close,
  numberOfPackages,
  packg,
  rate,
  paymentType,
  longTerm_deadline_date,
  selectedRoomRateId,
  selectedCoupon,
  departureDate,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();
  const { register, watch } = useForm();
  const [payView, setPayView] = useState("START");
  const [triggerVault, setTriggerVault] = useState(false);
  const [user, setUser] = useState([]);
  const { exactTrip, setExactTrip, currentAccount, setPaymentCouponCode } =
    vaultStore;
  const { firstName, lastName, email, id, phoneNumber } = user;

  const [initiateStripePayment, setInitiateStripePayment] = useState(false);
  const [wireSuccess, setWireSuccess] = useState(false);
  const [fundsConfirmed, setFundsConfirmed] = useState({
    status: false,
    amount: "",
  });

  const [createVault] = useMutation(TRIPVAULT_MUTATION, {
    refetchQueries: [{ query: LOAD_SAVINGSACCOUNT }, { query: COUPONS }],
  });

  // this is due to autosave logic, if this modal is called of autossave, you mininum amount as the total saving goal
  const minimum_amount =
    exactTrip?.balance == 0
      ? Math.ceil(parseInt(exactTrip?.savings_goal) * 0.3)
      : 0;

  // Format currency helper
  const formatCurrency = useCallback((amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
    }).format(amount || 0);
  }, []);

  const [paymentMethod, setPaymentMethod] = useState("STRIPE");

  const userInputedAmount = watch("addFundsAmount");

  function roundUpTwoDecimals(num) {
    return Math.ceil(num * 100) / 100;
  }

  // For Stripe

  const amount =
    paymentType === "vault"
      ? userInputedAmount
      : paymentType === "FULL"
      ? parseFloat(rate)
      : 0;

  const transactionFee = roundUpTwoDecimals(parseFloat(amount) * 0.029 + 0.3);
  const totalCharge = Number(parseFloat(amount) + transactionFee);

  const totalStripeAmount = roundUpTwoDecimals(
    parseFloat(amount) + totalCharge * 0.029 + 0.3,
  );

  const disableBtn =
    paymentType === "vault"
      ? amount < Math.ceil(Number(exactTrip?.trip?.savings_goal) * 0.3)
      : false;

  const response = useQuery(LOAD_PROFILE_INFO);

  useEffect(() => {
    if (response.data) {
      setUser(response.data.me.user);
    } else if (
      response.observable.last.error?.networkError?.statusCode == 401
    ) {
      logoutUser(navigate);
      warningToast(
        "Warning",
        response.observable.last.error?.networkError?.statusCode,
      );
    }
  }, [response.data, response]);

  // FOR STRIPE

  const [wireTransfer, { loading: wiring }] = useMutation(WIRE_TRANSFER, {
    refetchQueries: [{ query: LOAD_WALLET }, { query: LOAD_SAVINGSACCOUNT }],
  });

  const paywithWire = () => {
    wireTransfer({
      variables: {
        savings_account_id: exactTrip?.trip?.id || null,
        transaction_type: "SAVINGS_ACCOUNT_DEPOSIT",
        account_id: exactTrip.trip.id,
      },
    })
      .then((response) => {
        if (response?.data?.createWireTransfer?.__typename === "BadRequest") {
          warningToast("Warning", response?.data?.createWireTransfer?.message);
        }
        if (response?.data?.createWireTransfer?.__typename === "Success") {
          setWireSuccess(true);
        }
      })
      .catch((error) => {
        errorToast("Error", error ? error?.message : "An error occured");
      });
  };

  // Transfer
  const [transfer] = useMutation(TRANSFER_FUNDS_MUTATION, {
    refetchQueries: [{ query: LOAD_WALLET }, { query: LOAD_SAVINGSACCOUNT }],
  });

  const [resendVerification, { isLoading: verifyLoading }] = useMutation(
    RESEND_EMAIL_VERIFICATION_MUTATION,
  );

  const handleVerify = async () => {
    try {
      const response = await resendVerification({
        variables: {
          email: user?.email,
        },
      });

      if (response?.data?.resendEmailVerification?.__typename === "Success") {
        successToast(
          "Success",
          response?.data?.resendEmailVerification?.message,
        );
      } else {
        errorToast("Error", response?.data?.resendEmailVerification?.message);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const debitFromWallet = () => {
    setSubmitting(true);

    transfer({
      variables: {
        source_current_account_id: currentAccount.id,
        transfer_amount: amount,
        destination_savings_account_id: exactTrip.trip.id,
        user_id: id,
      },
    })
      .then((response) => {
        if (response.data.transfer.__typename === "BadRequest") {
          warningToast("Warning", response.data.transfer.message);
        }
        if (response.data.transfer.__typename === "TransferResultSuccess") {
          successToast("Success", "Transfer successful");
          setFundsConfirmed({ status: true, amount: amount });
        }
      })
      .catch((error) => {
        errorToast("Error", error ? error?.message : "An error occured");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  useEffect(() => {
    const createTripVault = async () => {
      const payload = {
        package: packg?.id,
        autosave: false,
        group_type: "PERSONAL",
        savings_type: "PACKAGE",
        room_rate_id: selectedRoomRateId,
        number_adults: packg.number_adults,
        number_children: packg?.number_children || 0,
        number_infants: packg.number_infants || 0,
        number_packages: parseInt(numberOfPackages),
        payment_type: "FULL",
        target_date:
          packg?.duration_type === "LONG_TERM"
            ? longTerm_deadline_date
            : packg?.booking_deadline_date,
        couponCode: selectedCoupon?.couponCode,
        travel_start_date:
          packg?.duration_type === "LONG_TERM"
            ? departureDate
            : packg?.departure_date,
      };

      try {
        const response = await createVault({
          variables: payload,
        });

        if (
          response.data.addTripVault.__typename === "AddSavingsAccountSuccess"
        ) {
          setExactTrip(response.data.addTripVault.savingsAccount);
          successToast("Success", "Vault successfully created");
          if (paymentMethod === "STRIPE") {
            setInitiateStripePayment(true);
            setPayView("STRIPE_VIEW");
          } else if (paymentMethod === "WIRE_TRANSFER") {
            setPayView("WIRE_VIEW");
          } else {
            setPayView("WALLET_VIEW");
          }
        } else if (
          response.data.addTripVault.__typename === "BadRequest" &&
          response.data.addTripVault.message === "Un-verified user!"
        ) {
          setTriggerVault(false);
          buttonToast(
            "Action Required",
            response.data.addTripVault.message,
            "Verify Now",

            () => handleVerify(),
            "warning",
          );
        } else {
          setTriggerVault(false);
          warningToast("Warning", response.data.addTripVault.message);
        }
      } catch (error) {
        setTriggerVault(false);
        errorToast("Error", error?.message);
      }
    };

    if (paymentType !== "vault" && triggerVault) {
      createTripVault();
    }
  }, [paymentType, triggerVault]);

  return (
    <div className="h-full overflow-y-scroll">
      {payView === "START" && (
        <div>
          <section>
            <div className="p-4 border-b border-black-100/10 flex items-start justify-between">
              <div className="">
                <h3 className="text-[#1D2939] font-bold text-lg">
                  {paymentType === "vault"
                    ? "Add money to trip vault"
                    : "Select Payment Method"}
                </h3>
                <p className="text-sm text-[#525866] mt-1">
                  {paymentType === "vault"
                    ? "Start saving towards your trip."
                    : "Where do you want us to withdraw this money from?"}
                </p>
              </div>
              <button onClick={close}>
                <CloseIcon />
              </button>
            </div>

            {paymentType !== "vault" && (
              <ul className="p-4 flex items-center gap-x-2 ">
                <li className="flex items-center gap-x-1">
                  <GrCheckmark className="bg-[#1FC16B] h-5 w-5 p-1.5 rounded-full text-white-100" />
                  <span className="text-gray-500 text-xs">
                    Package selection
                  </span>
                  <BiRightArrow className="text-[8px]" />
                </li>
                <li className="flex items-center gap-x-1">
                  <GrCheckmark className="bg-[#1FC16B] h-5 w-5 p-1.5 rounded-full text-white-100" />

                  <span className="text-gray-500 text-xs">
                    Checkout package
                  </span>
                  <BiRightArrow className="text-[8px]" />
                </li>
                <li className="flex items-center gap-x-1">
                  <span className="h-5 w-5 rounded-full border border-black-100/30 bg-blue-100 text-white-100 flex items-center justify-center">
                    3
                  </span>{" "}
                  <span className="text-gray-500 text-xs">Payment method</span>
                </li>
              </ul>
            )}
          </section>

          <section
            style={{
              height: "calc(100% - 120px)",
            }}
          >
            <article className="h-full overflow-y-scroll relative ">
              <section className="px-2 lg:px-4 rounded-lg">
                <div
                  style={{
                    height: "calc(100% - 170px)",
                  }}
                  className="space-y-3 overflow-y-scroll px-2 rounded-lg bg-[#F5F7F9] w-full py-2"
                >
                  {paymentType === "vault" && (
                    <article className="bg-white-100 p-2">
                      <label className="text-sm font-medium text-black-100">
                        How much do you want to add now?
                      </label>
                      <div className="mt-2">
                        <Input
                          name="addFundsAmount"
                          placeholder={"$ 0.00"}
                          type="number"
                          className={`${
                            disableBtn
                              ? " bg-red-100 "
                              : "border border-[#E1E4EA] bg-white-100 "
                          } rounded-lg w-full px-3 py-2`}
                          inputClass="w-full"
                          required
                          register={register}
                          registerOptions={{ required: true }}
                        />{" "}
                      </div>
                    </article>
                  )}
                  <article className="bg-white-100 p-2">
                    {paymentType === "vault" && (
                      <label className="text-sm font-medium text-black-100">
                        Select payment method{" "}
                      </label>
                    )}

                    <div className="space-y-3">
                      <div
                        onClick={() => {
                          setPaymentMethod("STRIPE");
                        }}
                        className="cursor-pointer bg-[#F2F4F7] flex items-start justify-between p-3 rounded-lg"
                      >
                        <div className="flex gap-x-2">
                          <StripeIcon />
                          <div>
                            <div className="flex items-center gap-x-2">
                              <span className="font-bold text-sm text-gray-500">
                                Stripe
                              </span>
                            </div>

                            <p className="text-xs text-[#475467]">
                              Pay for your package from a debit or credit card
                              on stripe instantly. Reservation should be in few
                              minutes.
                            </p>
                          </div>
                        </div>

                        <div>
                          {paymentMethod === "STRIPE" ? (
                            <RadioOn />
                          ) : (
                            <RadioOff />
                          )}
                        </div>
                      </div>

                      <div
                        onClick={() => setPaymentMethod("WIRE_TRANSFER")}
                        className="cursor-pointer bg-[#F2F4F7] flex items-start justify-between p-3 rounded-lg"
                      >
                        <div className="flex gap-x-2">
                          <WireTransferIcon />
                          <div>
                            <div className="flex items-center gap-x-2">
                              <span className="font-bold text-sm text-gray-500">
                                Pay with wire transfer
                              </span>
                            </div>

                            <p className="text-xs text-[#475467]">
                              Use money from your travelbay wallet to pay for
                              your package instantly. Reservation should be in
                              seconds.{" "}
                            </p>
                          </div>
                        </div>

                        <div>
                          {paymentMethod === "WIRE_TRANSFER" ? (
                            <RadioOn />
                          ) : (
                            <RadioOff />
                          )}
                        </div>
                      </div>

                      <div
                        onClick={() => setPaymentMethod("WALLET")}
                        className="cursor-pointer bg-[#F2F4F7] flex items-start justify-between p-3 rounded-lg"
                      >
                        <div className="flex gap-x-2">
                          <WalletIcon />
                          <div>
                            <div className="flex items-center gap-x-2">
                              <span className="font-bold text-sm text-gray-500">
                                Travelbay Wallet
                              </span>
                              <span className="bg-white-100 px-2 py-1 rounded-full font-bold text-[10px] text-gray-500">
                                {formatCurrency(currentAccount?.balance)}
                              </span>
                            </div>

                            <p className="text-xs text-[#475467]">
                              Use money from your travelbay wallet to pay for
                              your package instantly. Reservation should be in
                              seconds.{" "}
                            </p>
                          </div>
                        </div>

                        <div>
                          {paymentMethod === "WALLET" ? (
                            <RadioOn />
                          ) : (
                            <RadioOff />
                          )}
                        </div>
                      </div>
                    </div>
                  </article>

                  {paymentType === "vault" ? (
                    <div
                      className={`${
                        disableBtn ? "bg-red-100/20" : "bg-[#E9F6FC]"
                      }  flex items-start gap-2 text-sm text-[#101C28] w-full p-2 sm:p-4`}
                    >
                      <InfoFill />
                      <p className="">
                        Secure this offer by adding at least{" "}
                        <span className="text-blue-400">
                          {formatter.format(
                            Math.ceil(
                              Number(exactTrip?.trip?.savings_goal) * 0.3,
                            ),
                          )}{" "}
                        </span>{" "}
                        in the next 6 hours!
                      </p>
                    </div>
                  ) : (
                    <div className="bg-[#E9F6FC] flex items-start gap-2 text-sm text-[#101C28] w-full p-2 sm:p-4">
                      <InfoFill />
                      <p className="flex-1">
                        Booking for this trip ends on{" "}
                        <span className="text-sm font-medium">
                          {packg?.duration_type === "LONG_TERM"
                            ? moment(longTerm_deadline_date).format("dddd, ll.")
                            : moment(packg?.booking_deadline_date).format(
                                "dddd, ll.",
                              )}{" "}
                        </span>
                        Also note that there’s a non-refundable service charge
                        of {""}
                        <span className="font-medium">
                          ${packg?.non_refundable_amount}
                        </span>{" "}
                        after booking this package.
                      </p>
                    </div>
                  )}

                  {paymentType === "vault" ? (
                    <div className="border-t border-black-100/20 py-3 text-base text-[#101C28]">
                      <span className="font-medium text-sm uppercase">
                        Checkout summary
                      </span>

                      <div className="flex items-center justify-between">
                        <span className="text-sm text-[#667085]">
                          {exactTrip?.trip?.name} ({numberOfPackages}){" "}
                        </span>

                        <span className="text-sm font-bold text-gray-500 ">
                          {" "}
                          {formatCurrency(amount)}
                        </span>
                      </div>

                      {paymentMethod === "STRIPE" && amount > 1 && (
                        <div className="flex items-center justify-between">
                          <span className="text-sm text-[#667085]">
                            Transaction fees
                          </span>

                          <span className="text-sm font-bold text-gray-500 ">
                            {" "}
                            {formatCurrency(transactionFee)}
                          </span>
                        </div>
                      )}

                      <div className="mt-3 flex items-center justify-between">
                        <span className="text-[#667085] text-base">
                          Total Price
                        </span>
                        <span className="text-blue-200 font-bold text-xl">
                          {formatCurrency(
                            paymentMethod === "STRIPE"
                              ? totalStripeAmount
                              : amount,
                          )}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="border-t border-black-100/20 py-3 text-base text-[#101C28]">
                      <span className="font-medium text-sm uppercase">
                        Checkout summary
                      </span>

                      <div className="flex items-center justify-between">
                        <span className="text-sm text-[#667085]">
                          {packg?.name} ({numberOfPackages}){" "}
                        </span>

                        <span className="text-sm font-bold text-gray-500 ">
                          {" "}
                          {formatCurrency(amount)}
                        </span>
                      </div>

                      {amount && paymentMethod === "STRIPE" && (
                        <div className="flex items-center justify-between">
                          <span className="text-sm text-[#667085]">
                            Transaction fees
                          </span>

                          <span className="text-sm font-bold text-gray-500 ">
                            {" "}
                            {formatCurrency(transactionFee)}
                          </span>
                        </div>
                      )}

                      <div className="mt-3 flex items-center justify-between">
                        <span className="text-[#667085] text-base">
                          Total Price
                        </span>
                        <span className="text-blue-200 font-bold text-xl">
                          {formatCurrency(
                            paymentMethod === "STRIPE"
                              ? totalStripeAmount
                              : amount,
                          )}
                        </span>
                      </div>
                    </div>
                  )}

                  {paymentMethod === "STRIPE" && (
                    <div className="">
                      {paymentType === "vault" ? (
                        <Button
                          onClick={() => {
                            setInitiateStripePayment(true);
                            setPayView("STRIPE_VIEW");
                          }}
                          disabled={disableBtn}
                          className="w-full px-2 py-1"
                          isBlue
                          text="Add money"
                        />
                      ) : (
                        <Button
                          onClick={() => setTriggerVault(true)}
                          disabled={disableBtn}
                          className="w-full px-2 py-1"
                          isBlue
                          text="Book now and get 3% OFF"
                        />
                      )}
                    </div>
                  )}

                  {paymentMethod === "WALLET" && (
                    <div className="mt-6">
                      {paymentType === "vault" ? (
                        <Button
                          onClick={() => setPayView("WALLET_VIEW")}
                          disabled={disableBtn}
                          className="w-full px-2 py-1"
                          isBlue
                          text="Add money"
                        />
                      ) : (
                        <Button
                          onClick={() => setTriggerVault(true)}
                          disabled={disableBtn}
                          className="w-full px-2 py-1"
                          isBlue
                          text="Book now and get 3% OFF"
                        />
                      )}
                    </div>
                  )}

                  {paymentMethod === "WIRE_TRANSFER" && (
                    <div className="mt-6">
                      {paymentType === "vault" ? (
                        <Button
                          onClick={() => setPayView("WIRE_VIEW")}
                          disabled={disableBtn}
                          className="w-full px-2 py-1"
                          isBlue
                          text="Add money"
                        />
                      ) : (
                        <Button
                          onClick={() => setTriggerVault(true)}
                          disabled={disableBtn}
                          className="w-full px-2 py-1"
                          isBlue
                          text="Book now and get 3% OFF"
                        />
                      )}
                    </div>
                  )}
                </div>
              </section>
            </article>
          </section>
        </div>
      )}

      {payView === "WALLET_VIEW" && (
        <section className="p-4">
          {!fundsConfirmed.status && (
            <div>
              <div className="flex gap-x-6 items-center">
                <span
                  onClick={() => setPayView("START")}
                  className="cursor-pointer "
                >
                  <BsChevronLeft size={20} fill="#5D6D8F" />
                </span>
                <span className="text-[#093549] font-bold text-[22px]">
                  Add funds from wallet
                </span>
              </div>

              <div className="flex py-8 space-y-3 flex-col">
                <div className="flex items-center h-[100px] text-center w-full mx-auto border-b-[1.5px] border-black-100/10 px-2">
                  <span className="text-2xl text-[#093549] font-bold ">$</span>
                  <div className=" border-0 font-medium text-[#093549]/60 text-2xl w-full">
                    {currentAccount?.balance} - {amount}
                  </div>
                </div>
                {currentAccount?.balance - amount < 0 && (
                  <div className="flex flex-col gap-y-3 justify-center text-center">
                    <img
                      src={Fail}
                      alt=""
                      className="w-[50%] max-w-[150px] mx-auto"
                    />
                    <p className="text-[#093549]/80 text-[20px] font-bold text-center">
                      Insufficient wallet balance
                    </p>
                    <p className="text-gray-100 text-center text-[14px]">
                      You do not have enough balance in your wallet to complete
                      this transaction. Please fund your wallet and try again
                    </p>
                  </div>
                )}
              </div>

              <div>
                <Button
                  text={"Confirm"}
                  isBlue
                  disabled={
                    // !amount?.length ||
                    // amount.trim() === "" ||
                    submitting || currentAccount?.balance - amount < 0
                  }
                  loading={submitting}
                  onClick={() => debitFromWallet()}
                />
              </div>
            </div>
          )}
        </section>
      )}

      {payView === "STRIPE_VIEW" && (
        <section className="p-4">
          {initiateStripePayment && !fundsConfirmed.status && (
            <div className="w-full">
              <div className="flex gap-x-6 items-center mb-4">
                <span
                  onClick={() => setPayView("START")}
                  className="cursor-pointer "
                >
                  <BsChevronLeft size={20} fill="#5D6D8F" />
                </span>
                <span className="text-[#093549] font-bold text-[22px]">
                  Add funds with Stripe
                </span>
              </div>

              <div>
                <Payment
                  amount={totalStripeAmount}
                  phoneNumber={phoneNumber}
                  email={email}
                  name={firstName + "" + lastName}
                  id={id}
                  setFundsConfirmed={setFundsConfirmed}
                  disabled={paymentMethod ? false : true}
                  paymentDetails={{
                    account_id: exactTrip.trip.id,
                    account_type: "SAVINGS_ACCOUNT_DEPOSIT",
                  }}
                />
              </div>
            </div>
          )}
        </section>
      )}

      {payView === "WIRE_VIEW" && !wireSuccess ? (
        <div className="p-4">
          <div>
            <div className="flex gap-x-6 items-center">
              <span
                onClick={() => setPayView("START")}
                className="cursor-pointer "
              >
                <BsChevronLeft size={20} fill="#5D6D8F" />
              </span>
              <span className="text-[#093549] font-bold text-[22px]">
                Wire Transfer
              </span>
            </div>

            <div className="mt-[16px] text-[15px] text-[#093549]">
              For Wire transactions, make transfer into the account details
              below
            </div>

            <div className="mt-[16px] text-[14px]">
              <span className="text-[#06202C] mb-[16px] font-bold text-[17px]">
                Beneficiary
              </span>
              <div className="flex mt-[4px] items-center font-medium justify-between">
                <span className="text-[#5D6D8F]">Beneficiary Name</span>
                <span className="text-[#093549]">Tbay Africa Inc.</span>
              </div>

              <div className="flex mt-[4px] items-center font-medium justify-between">
                <span className="text-[#5D6D8F]">Account Number</span>
                <span className="text-[#093549]">117067085804</span>
              </div>

              <div className="flex mt-[4px] items-start font-medium justify-between">
                <span className="text-[#5D6D8F]">Beneficiary Address</span>
                <span className="text-[#093549] text-end w-[50%]">
                  220 East, 23rd Street, Suite 400. New York city, NY 10010
                </span>
              </div>
            </div>

            <div className="mt-[16px] text-[14px]">
              <span className="text-[#06202C] text-[17px] mb-[16px] font-bold">
                Receiving Bank Details
              </span>

              <div className="flex  mt-[4px] items-center font-medium justify-between">
                <span className="text-[#5D6D8F]">ABA Routing Number</span>
                <span className="text-[#093549]">103913434</span>
              </div>

              <div className="flex  mt-[4px] items-center font-medium justify-between">
                <span className="text-[#5D6D8F]">Bank Name</span>
                <span className="text-[#093549]">Regent Bank</span>
              </div>
            </div>

            <div className="mt-[16px] text-[14px]">
              <span className="text-[#06202C] mb-[16px] font-bold text-[17px]">
                Additional Details
              </span>

              {paymentType === "vault" ? (
                <div className="flex items-center font-medium justify-between">
                  <span className="text-[#5D6D8F]">Trip Vault ID</span>
                  <span className="text-[#093549]">{exactTrip.trip.id} </span>
                </div>
              ) : (
                <div className="flex items-center font-medium justify-between">
                  <span className="text-[#5D6D8F]">Wallet ID</span>
                  <span className="text-[#093549]">{currentAccount.id} </span>
                </div>
              )}
            </div>

            <div className="mt-[24px] text-[14px] text-[#093549] bg-[#E5F4FB] rounded-[8px] p-[12px]">
              <span className="font-bold">Instructions</span>
              <br />
              <span className="mt-[4px]">
                Kindly ensure you include the following in your description when
                making a wire transfer:
              </span>

              <div className="flex gap-[8px] items-center">
                <span>•</span>
                <span>Email Address</span>
              </div>

              <div className="flex gap-[8px] items-center">
                <span>•</span>
                <span>Purpose e.g: Trip Vault or Wallet Deposit</span>
              </div>

              <div className="flex gap-[8px] items-center">
                <span>•</span>
                <span>Trip Vault ID</span>
              </div>

              <div>
                <span>
                  You can separate this using a “comma” in the description
                </span>
                <br />
                <span className="font-medium">
                  Thank you for trusting travelbay!
                </span>
              </div>
            </div>

            <div className="mt-[36px] flex flex-col gap-[16px]">
              <Button
                onClick={paywithWire}
                loading={wiring}
                isBlue
                text="I have made this transfer"
              />
              <Button
                onClick={() => setPayView("START")}
                className="border gap-[13px] flex flex-row-reverse items-center justify-center text-[14px] rounded-lg border-blue-100 h-12 hover:bg-[#d2ecf8] hover:border-[2px] font-medium w-[129px]"
                text="Cancel"
              />
            </div>
          </div>
        </div>
      ) : payView === "WIRE_VIEW" && wireSuccess ? (
        <div className="flex flex-col justify-center items-center p-4">
          <img alt="" src={images.wiresuccess} />
          <div className="my-[8px] text-[#093549] font-bold text-[20px]">
            Thank you!
          </div>
          <div className="text-[#5D6D8F] mb-[36px] text-center">
            Your trip vault would be updated soon. Kindly reach out to us with a
            proof of payment in 24 hours if this doesn’t happen{" "}
          </div>

          <Button
            onClick={() => {
              navigate(DASHBOARD);
              close();
            }}
            isBlue
            text="Go to dashboard"
          />
        </div>
      ) : (
        ""
      )}

      {fundsConfirmed.status && (
        <div className="py-5 px-4">
          <span
            onClick={close}
            className="cursor-pointer absolute top-3 left-3 "
          >
            <Close />
          </span>
          <div className="flex space-y-4 flex-col items-center text-center font-medium">
            <img src={Success} alt="" className="w-[25%] mb-8 " />
            <span className="w-[70%] text-[#093549] font-medium text-2xl ">
              Success
            </span>
            <span className="text-gray-100 w-[80%]">
              You have added $
              <span>
                {paymentMethod === "STRIPE" ? amount : fundsConfirmed.amount}
              </span>{" "}
              to your vault{" "}
            </span>
            <Button
              onClick={() => {
                navigate(DASHBOARD);
              }}
              isBlue
              text={"Go back to dashboard"}
              className="max-w-[450px]"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentMethod;
